import React, { useEffect, useState } from "react";
import Axios from "axios";
import AOS from "aos";
import "aos/dist/aos.css";
import { Container, Row, Col, Button, Collapse, Card, CardBody } from "reactstrap";
import ExamplesNavbar from "../../components/Navbars/ExamplesNavbar";
import FaqsPageHeader from "../../components/Headers/FaqsPageHeader";
import DefaultFooter from "../../components/Footers/DefaultFooter";

const FaqsPage = () => {
    const [click, setClick] = useState(null);
    const [dataFaq, setData] = useState([]);

    const getData = async () => {
        try {
            const response = await Axios.get(`${process.env.REACT_APP_API_URL}/faqs/readFaq`);
            const data = response.data;
            setData(data);
        } catch (error) {
            console.error("Error fetching FAQ data:", error);
        }
    };

    useEffect(() => {
        document.body.classList.add("faq-page", "sidebar-collapse");
        document.documentElement.classList.remove("nav-open");
        window.scrollTo(0, 0);

        getData();

        // Initialize AOS
        AOS.init({
            duration: 800, // Animation duration
            easing: "ease-in-out", // Animation easing
            once: true, // Animation happens only once
        });

        return () => {
            document.body.classList.remove("faq-page", "sidebar-collapse");
        };
    }, []);

    const toggle = (index) => {
        setClick(click === index ? null : index);
    };

    return (
        <>
            <ExamplesNavbar />
            <div className="wrapper">
                <FaqsPageHeader />
                <div className="section">
                    <section className="faq">
                        <Container>
                            <Row>
                                {dataFaq.map((val, index) => (
                                    <Col
                                        md="12"
                                        key={index}
                                        className="mb-3"
                                        data-aos="fade-up" // AOS animation
                                    >
                                        <Card>
                                            <Button
                                                color="link"
                                                onClick={() => toggle(index)}
                                                className="accordion d-flex justify-content-between align-items-center"
                                                style={{
                                                    backgroundColor: "#002855",
                                                    color: "#ffffff",
                                                    padding: "15px",
                                                    borderRadius: "4px",
                                                    width: "100%",
                                                    textAlign: "left",
                                                }}
                                            >
                                                <h5 style={{ marginBottom: 0 }}>
                                                    {val.pertanyaan}
                                                </h5>
                                                <span>{click === index ? "▲" : "▼"}</span>
                                            </Button>
                                            <Collapse
                                                isOpen={click === index}
                                                style={{
                                                    transition: "height 0.4s ease",
                                                }}
                                            >
                                                <CardBody
                                                    style={{
                                                        backgroundColor: "#ffffff",
                                                        color: "#000000",
                                                        padding: "20px",
                                                    }}
                                                    data-aos="fade-in" // AOS animation
                                                >
                                                    <p>{val.jawaban}</p>
                                                </CardBody>
                                            </Collapse>
                                        </Card>
                                    </Col>
                                ))}
                            </Row>
                        </Container>
                    </section>
                </div>
                <DefaultFooter />
            </div>
        </>
    );
};

export default FaqsPage;
